export default function MoonIcon({ theme }) {
   return(
      <>
         {theme === 'dark' ? 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3"><path d="M15.7,28.3c4.4,0,8.4-2,11-5.2c0.4-0.5,0-1.2-0.6-1.1c-6.9,1.3-13.2-4-13.2-10.9c0-4,2.1-7.7,5.6-9.7 c0.5-0.3,0.4-1.1-0.2-1.2C17.4,0.1,16.5,0,15.7,0C7.9,0,1.5,6.3,1.5,14.2C1.5,22,7.8,28.3,15.7,28.3z"/></svg>
            :
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3"><path d="M15.5,28.3c4.4,0,8.4-2,11-5.2c1.6-1.9-0.1-4.7-2.6-4.3c-4.6,0.9-8.8-2.6-8.8-7.2c0-2.7,1.4-5.1,3.7-6.4 C21,3.9,20.5,0.7,18,0.2C17.2,0.1,16.3,0,15.5,0C7.6,0,1.3,6.3,1.3,14.2C1.3,22,7.6,28.3,15.5,28.3z M15.5,2.7 c0.7,0,1.4,0.1,2.1,0.2c-3,1.7-5.1,5-5.1,8.7c0,6.3,5.7,11,11.9,9.9c-2.1,2.6-5.3,4.3-8.9,4.3c-6.4,0-11.5-5.2-11.5-11.5 S9.1,2.7,15.5,2.7z"/></svg>
         }
      </>
   );
}